import { render, staticRenderFns } from "./DragDropListItem.vue?vue&type=template&id=0454b49c&scoped=true&"
import script from "./DragDropListItem.vue?vue&type=script&lang=js&"
export * from "./DragDropListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454b49c",
  null
  
)

export default component.exports